<template>
  <ClientOnly>
    <div class="flex flex-col lg:flex-row lg:gap-2">
      <template v-for="(page, index) in breadcrumbsData" :key="index">
        <NuxtLink
          v-if="page.menu_url"
          :to="localePath(page?.menu_url)"
          class="hover:text-gray-medium transition-colors duration-100"
        >
          {{ page?.label }}
          {{ index !== breadcrumbsData?.length - 1 ? '→' : '' }}
        </NuxtLink>
      </template>
    </div>
  </ClientOnly>
</template>

<script setup lang="ts">
const localePath = useLocalePath()

const breadcrumbsData = useBreadcrumbs()
</script>
